import * as React from "react";
import { SVGProps } from "react";
const SvgCheckmark = (props: SVGProps<SVGSVGElement>) => <svg width={17} height={17} style={{
  marginTop: ".25em"
}} viewBox="0 0 17 17" {...props}><g transform="translate(1 1)" stroke="currentColor" fill="none" fillRule="evenodd"><circle cx={7.5} cy={7.5} r={7.5} /><path d="m3.227 7.196 2.48 2.917 5.52-6" /></g></svg>;
export default SvgCheckmark;